module.exports = __webpack_public_path__ + "img/summary_item_bg2.7e0931b5.png";